import { apolloClient } from 'App';
import { GetWarehouseDeliveriesQuery, WarehouseDeliveryFragmentFragment } from 'data/__generated__';
import { GET_WAREHOUSE_DELIVERIES } from 'data/queries/warehouseDeliveries';

export const warehouseDeliveryUpdatedHandler = (updatedDelivery: WarehouseDeliveryFragmentFragment) => {
    try {
        updateCacheForSearchDate(null);

        // If the delivery has a transfer date, try to update the query corresponding to this date
        if (updatedDelivery.deliveryDate) {
            updateCacheForSearchDate(updatedDelivery.deliveryDate);
        }
    } catch (error) {
        console.error('Error updating warehouse delivery cache:', error);
    }

    function updateCacheForSearchDate(searchDate: string | null) {
        try {
            const result = apolloClient.readQuery<GetWarehouseDeliveriesQuery>({
                query: GET_WAREHOUSE_DELIVERIES,
                variables: {
                    searchDate,
                },
            });

            if (!result) {
                return; // This specific query is not in cache
            }

            const currentDeliveries = result.warehouseDeliveries || [];
            const deliveryIds = currentDeliveries.map(({ _id }) => _id);

            const data = {
                warehouseDeliveries: deliveryIds.includes(updatedDelivery._id)
                    ? currentDeliveries.map((delivery) => {
                          if (delivery._id === updatedDelivery._id) {
                              return updatedDelivery;
                          }
                          return delivery;
                      })
                    : [...currentDeliveries, updatedDelivery],
            };

            apolloClient.writeQuery({
                query: GET_WAREHOUSE_DELIVERIES,
                variables: {
                    searchDate,
                },
                data,
            });
        } catch (readError) {
            // Silently fail
        }
    }
};
